import {connect} from 'react-redux';

import Airport from './Airport';
import Pin from './Pin';
import Map from './Map';

const Wrapper = ({url, start, destination, active, airports, isAnonymous}) => (
    <div className="map-wrapper">
        {start && <Pin {...start} direction="up" />}
        {destination && <Pin {...destination} direction="down" />}
        {airports.map(airport => <Airport {...airport} key={airport.icao} />)}
        <Map isAnonymous={isAnonymous} />
    </div>
);

const mapStateToProps = ({start, destination, airports}) => ({
    airports,
    destination,
    start,
});

export default connect(mapStateToProps)(Wrapper);
